import { render, staticRenderFns } from "./crearCotizacionProveedor.vue?vue&type=template&id=4b037e07"
import script from "./crearCotizacionProveedor.vue?vue&type=script&lang=js"
export * from "./crearCotizacionProveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports